export const replaceUrlIfOnPage = (newUrl: string) => {
  const [targetPathname] = newUrl.split('?');
  if (window.location.pathname === targetPathname) {
    window.history.replaceState(window.history.state, '', newUrl);
  }
};
